import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss']
,  standalone: false
})
export class WelcomeComponent implements OnInit {
  @Input() testName: string;

  ngOnInit() {
    //This blank function is mandatory.
  }
 
}
